module.exports = __webpack_public_path__ + "df0ae8cf08ef7ed6de6aad5f489ddd55.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Medium.ttf
// module id = 983
// module chunks = 0